import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { omit, isEmpty } from 'lodash';
import { withRouter } from 'react-router';
import { length } from 'redux-form-validators';

import { PATH } from '../../../constants/path';
import { NAME_LENGTH, FIRSTNAME_LENGTH } from '../../../constants/form';

import { registerUser } from '../../../services/authentication/register/actions';

import {
    FormComponent,
    EmailInputFieldComponent,
    PasswordInputFieldComponent,
    TextInputFieldComponent,
    RadioInputFieldComponent,
    CheckboxInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';

import './RegisterFormComponent.scss';

const civilities = [
    { label: 'M', value: 'MONSIEUR' },
    { label: 'Mme', value: 'MADAME' }
];
const CONFIRMATIONS_FIELD_NAME = ['emailconfirm', 'passwordconfirm', 'cguacceptance'];

class RegisterFormComponent extends React.Component {
    submit = values => {
        // API does not need confirmations fields
        this.props.registerUser(omit(values, CONFIRMATIONS_FIELD_NAME), () => {
            this.props.history.push(PATH.HOME_PATH);
        });
    };

    render() {
        const {
            errorMessage,
            i18n,
            i18nCommon,
            BRAND_NAME,
            requestSubmit,
            successSubmit,
            errorSubmit
        } = this.props;

        if (!successSubmit) {
            return (
                <FormComponent
                    form="register-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    className="register-form"
                    submitText={i18n.BUTTON_REGISTER}>
                    <RadioInputFieldComponent
                        name="civility"
                        label={i18n.CIVILITY}
                        options={civilities}
                        isRequired
                        isInlineLabel
                    />
                    <TextInputFieldComponent
                        name="lastname"
                        placeholder={i18n.LASTNAME}
                        isRequired
                        validate={[
                            length({
                                max: NAME_LENGTH,
                                msg: format(
                                    i18nCommon.TEXT_TOOLONG,
                                    NAME_LENGTH,
                                    NAME_LENGTH > 1 ? 's' : ''
                                )
                            })
                        ]}
                    />
                    <TextInputFieldComponent
                        name="firstname"
                        placeholder={i18n.FIRSTNAME}
                        isRequired
                        validate={[
                            length({
                                max: FIRSTNAME_LENGTH,
                                msg: format(
                                    i18nCommon.TEXT_TOOLONG,
                                    FIRSTNAME_LENGTH,
                                    FIRSTNAME_LENGTH > 1 ? 's' : ''
                                )
                            })
                        ]}
                    />
                    <EmailInputFieldComponent name="email" placeholder={i18n.EMAIL} isRequired />
                    <PasswordInputFieldComponent
                        name="password"
                        placeholder={i18n.PASSWORD}
                        isRequired
                    />
                    <CheckboxInputFieldComponent
                        name="newsletterSubscribe"
                        options={[{ label: format(i18n.NEWSLETTER_TEXT, BRAND_NAME), value: 1 }]}
                    />
                    <CheckboxInputFieldComponent
                        name="cguacceptance"
                        options={[{ label: format(i18n.CGU_TEXT, BRAND_NAME), value: 1 }]}
                        minRequired={1}
                    />
                    <React.Fragment>
                        {errorMessage && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            );
        } else {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.REGISTER_SUCCESS}</p>
                </SuccessInfoComponent>
            );
        }
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        errorMessage: state.authentication.error,
        requestSubmit: state.authentication.fetching || false,
        successSubmit: state.authentication.isAuthenticated,
        errorSubmit: !isEmpty(state.authentication.error),
        i18n: state.i18n.page.REGISTER,
        i18nCommon: state.i18n.feature.form,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
}

const mapDispatchToProps = {
    registerUser
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterFormComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/register/RegisterFormComponent.js